"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var LayerListView_1 = __importDefault(require("./LayerListView"));
var LayerAddView_1 = __importDefault(require("./LayerAddView"));
var LayerEditView_1 = __importDefault(require("./LayerEditView"));
var LayerDetailView_1 = __importDefault(require("./LayerDetailView"));
var LayerPage = react_1.default.memo(function () { return react_1.default.createElement(react_router_dom_1.Routes, null,
    react_1.default.createElement(react_router_dom_1.Route, { path: "list", element: react_1.default.createElement(LayerListView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "add", element: react_1.default.createElement(LayerAddView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "edit/:id", element: react_1.default.createElement(LayerEditView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "detail/:id", element: react_1.default.createElement(LayerDetailView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "list", replace: true }) })); });
exports.default = LayerPage;
